
import axios from 'axios';
import { FetchOptions } from '../components/interfaces';
// import { resetToken } from '../services/http-service';
import { getJwt, resetToken } from '../utils/auth';

const noRedirectUnAuthorize = [
  /\/api\/collections$/,
  /\/api\/users\/login-alternate$/,
  /\/api\/users\/.+\/password$/,
  /\/resources\/exports.+$/
];

axios.interceptors.response.use(null, error => {
  const response = error.response;
  if (response && response.status) {
    // Logger.log('Axios::Interceptors');
    if (response.status === 401) {
      for (const item of noRedirectUnAuthorize) {
        const noRedirect = item.test(response.config.url);
        if (noRedirect) {
          return Promise.reject(error);
        }
      }
      const token = getJwt();
      if (token) {
        window.location.href = '/logout';
      }
    }
  }
  return Promise.reject(error);
});

export const URL_ROOT = process.env.REACT_APP_API_ROOT || '';
export const API_BASE = URL_ROOT + '/api';

export const rawHandler = async<T>(action: () => Promise<T>) => {
  try {
    return ((await action()) as any);
  }
  catch (e) {
    if (e && e.response) {
      console.error(e.response);
    }
    else {
      console.error(e);
    }
    throw e;
  };
}

export const handler = async (action: () => Promise<any>) => {
  return (await rawHandler(action)).data;
}

export const provideFetchOptions = (options: FetchOptions, defaults?: Partial<FetchOptions>) => {
  if (options == null) options = {};
  if (typeof defaults !== 'object') defaults = {};
  options.q = options.q ?? defaults.q ?? '';
  options.count = options.count ?? defaults.page ?? 10;
  options.page = options.page ?? defaults.page ?? 1;
  options.sort = options.sort ?? defaults.sort ?? 'createdAt';
  options.sortOrder = options.sortOrder ?? defaults.sortOrder ?? 'desc';
  return options;
}

resetToken();

const http = {
  URL_ROOT,
  API_BASE,
  handler,
  rawHandler,
  provideFetchOptions,
  get: axios.get,
  put: axios.put,
  post: axios.post,
  patch: axios.patch,
  delete: axios.delete,
  options: axios.options,
};

export default http;
